import { createContext, useContext } from "react"

import { ErrorProps } from "components/AppErrorModal"

type ErrorContextType = {
  error: ErrorProps | null
  handleError: (error: ErrorProps) => void
  clearError: () => void
}

// Create context without a default value to ensure undefined when used outside provider
export const ErrorContext = createContext<ErrorContextType | undefined>(
  undefined
)

export const useErrorModal = () => {
  const context = useContext(ErrorContext)
  if (!context) {
    throw new Error("useErrorModal must be used within an ErrorProvider")
  }
  return context
}
